import React from 'react';
import { district } from '../data/district';
export const DISTRICT_LOGO_URL = 'https://cdn.magicpatterns.com/patterns/generated-images/486aaf64-a229-4cee-b5b6-df735e370dc1.jpg';
export const POWERED_BY_AKKO_URL = 'https://cdn.magicpatterns.com/uploads/8megBdeHvdLaU53cpFicvZ/Akko_Authorized_Partner_Logo-_D5_Powered_by__Horizontal_Black_INTER_(Black).jpg';
export const AKKO_LOGO_URL = 'https://cdn.magicpatterns.com/uploads/abrBPeiRPxqBbxvRr8emEz/AKKO_logo_(1).png';
export function DistrictLogo({
  size = 'md'
}: {
  size?: 'md' | 'lg';
}) {
  return <span className={`flex w-full items-center justify-center rounded-md bg-white ${size === 'lg' ? 'px-6 py-4' : 'px-2 py-1.5'}`} data-id="element-36" data-mp="1hb9a0dku0ngp">
      <img src={DISTRICT_LOGO_URL} alt={`${district.name} logo`} className={size === 'lg' ? 'h-20 w-auto object-contain' : 'h-[46px] w-auto object-contain'} data-id="element-37" data-mp="17ibxco2itsq0" />
    </span>;
}

/**
 * Sidebar lockup exactly as it appears in the app: small light "Powered by"
 * text followed by the AKKO wordmark in a red badge, sitting directly on the
 * navy rail (no white plate).
 */
export function AkkoBadge({
  tone = 'dark'
}: {
  tone?: 'dark' | 'light';
}) {
  const textClass = tone === 'light' ? 'text-ink-500' : 'text-white/80';
  return <span className={`inline-flex items-center gap-1 text-[10px] leading-none ${textClass}`} data-id="element-38" data-mp="z47ftmbo2gus">
      Powered by
      <span className="inline-flex items-center rounded-[3px] bg-akko-red px-[5px] py-[3px] text-[10px] font-extrabold leading-none tracking-[0.02em] text-white" data-id="element-39" data-mp="l46bty03utb3">
        AKKO
      </span>
    </span>;
}
export function AkkoLogo({
  className = 'h-7 w-auto'
}: {
  className?: string;
}) {
  return <img src={AKKO_LOGO_URL} alt="AKKO" className={`${className} object-contain`} data-id="element-40" data-mp="g536sdk4kn34" />;
}